// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateViewerMutation($input: UpdateViewerInput!) {
    updateViewer(input: $input) {
      user {
        id
        email
        firstName
        lastName
        avatar
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
